import React from 'react';

const TaurusIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="65" r="25" stroke={color} strokeWidth="5"/>
    <path d="M35 40C35 25 40 15 50 15C60 15 65 25 65 40" stroke={color} strokeWidth="5" strokeLinecap="round"/>
  </svg>
);

export default TaurusIcon;
